<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs/>
          <div
            class="table-agile-info"
            v-if="pageData.length === 0" >
            暂无历史数据
          </div>
          <div
            class="table-agile-info"
            v-for="(testItem, index) in pageData"
            :key="index"
          >
            <div class="basic-title">
              <em>{{ testItem.add_time }} </em><!-- 列表显示基础班，历史记录显示时间-->
              <span>IELTS雅思能力测试（{{ testItem.qs_paper_type }}）</span><!-- 历史记录 显示-->
            </div>
            <div class="ieltsTest-cont">
              <el-row >
                <el-col
                  :span="4"
                  class="ieltsTest-left ieltsTest-left-top">
                  <span><em>雅思预测分数</em><em>{{ testItem.report_json[6].point }}</em></span>
                </el-col>
                <el-col :span="1"/>
                <el-col
                  :span="19"
                  class="ieltsTest-right ieltsTest-right-top">
                  <div class="ieltsTest-right-box">
                    <span v-if="true"><i>完成时间：</i>{{ testItem.add_time }}</span>
                    <span><i>答题耗时：</i>{{ testItem.done_time }}</span>
                  </div>
                  <div class="ieltsTest-right-box">
                    <span><i>总分：</i>{{ testItem.report_json[6].last_score }}</span>
                    <span><i>学习建议：</i>{{ testItem.report_json[6].comment }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row
                v-for="(item, index) in testItem.report_json"
                :key="index"
                v-if="index != 6">
                <el-col
                  :span="4"
                  class="ieltsTest-left">
                  <span>
                    <em>{{ item.name }}：{{ item.last_score }}</em>
                    <em>预测分数：{{ item.point }}</em>
                  </span>
                </el-col>
                <el-col :span="1">评语：</el-col>
                <el-col
                  :span="19"
                  class="ieltsTest-right">
                  <!--<el-input type="textarea" :rows="3" v-model="item.comment" disabled></el-input>-->
                  <span class="ieltsTest-span">{{ item.comment }}</span>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';

export default {
  data() {
    return {
      pageData: {}
    };
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
  },
  methods: {
    getData() {
      this.$http._post({
        url: `/index/ielts_test/getHistory/crmid/${this.$route.params.crmid}`,
      }).then((data) => {
        if (data.data !== '') {
          this.pageData = data.data;
        } else {
          this.$message.error('数据错误');
        }
      });
    }
  },
  mounted() {
    this.getData();
  },
};
</script>
<style scoped>
  .basic-title{
    cursor: inherit;
  }
  .basic-title span {
    margin-left: 30px;
  }
  .ieltsTest-button{
    margin-left: 245px;
  }
  .ieltsTest-left span{
    margin-right: 30px;
    display: inline-block;
    min-width: 135px;
    padding: 10px;
    border: 1px solid #409EFF;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #4e4e4e;
  }
  .ieltsTest-left span em {
    display: block;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    color: #409EFF;
  }
  .ieltsTest-left-top span {
    border-radius: 10px;
    background: #fff;
    border: #409EFF solid 2px;
    box-shadow: 1px 1px 3px #999;
  }
  .ieltsTest-left-top span em{
    font-size: 16px;
    font-weight: 400;
    color: #409EFF;
  }
  .ieltsTest-left-top span em:first-of-type{
    font-size: 14px;
  }
  .ieltsTest-left-top span em:last-of-type{
    font-size: 18px;
    color: #f00;
  }
  .ieltsTest-cont{
    margin: 20px;
  }
  .ieltsTest-cont .el-col-4 {
    width: auto;
  }
  .ieltsTest-cont .el-row{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
  }
  .ieltsTest-span{
    min-width: 870px;
    height: 66px;
    color:#000000 !important;
    border: 1px solid #cccccc;
  }
  .ieltsTest-right{
    min-width: 870px;
  }

  .ieltsTest-right-top {
    padding: 0;
    border: none;
    min-height: auto;
  }
  .ieltsTest-right .ieltsTest-right-box{
    width: 30%;
    float: left;
  }
  .ieltsTest-right span{
    padding: 5px 0;
    display: block;
    font-size: 14px;
    color: #409EFF;
  }
  .ieltsTest-right span i{
    margin-right: 6px;
    color: #303133;
    font-size: 16px;
    font-weight: bold;
  }
</style>
